
const links = {
    github:'https://github.com/tarunnsingh/alexa-community-jaipur',
    linkedin:'https://www.linkedin.com/company/aacjaipur/',
    instagram:'https://www.instagram.com/amazon_alexa_jaipur/',
    v1_website:'http://alexadevhub.herokuapp.com/',
    v2_website:'https://alexadevhub.netlify.app/',
    webinar1:'https://www.youtube.com/embed/vOZGa6WJQoE',
    contributors:'https://api.github.com/repos/alexa-dev-hub/alexa-community-jaipur/contributors',
    api:'https://alexadevhub.herokuapp.com',
    corsValidator:'https://cors-anywhere.herokuapp.com/'
}
export default links;
